import React from 'react';

import styles from './skeleton.module.scss';

type SkeltonProps = Omit<React.ComponentPropsWithoutRef<'span'>, 'style'> & {
  width: number; // unit: rem
  height: number; // unit: rem
};

export const Skeleton = ({ width, height, className, ...props }: SkeltonProps) => (
  <span
    className={className ? `${styles['skeleton']} ${className}` : styles['skeleton']}
    style={
      {
        '--skeleton-width': `${width}rem`,
        '--skeleton-height': `${height}rem`,
      } as React.CSSProperties
    }
    {...props}
  />
);
